{
  "de": {
    "signature": {
      "actions": {
        "clearSignature": "Unterschrift leeren",
        "edit": "Bearbeiten",
        "request": "Unterschrift anfordern",
        "save": "Speichern",
        "sign": "Unterschreiben"
      },
      "labels": {
        "add": "Hinzufügen",
        "add_customer_signatures": "Sie müssen Kundenunterschriften hinzufügen, bevor Sie speichern.",
        "add_team_member_signatures": "Sie müssen Unterschriften für Teammitglieder hinzufügen, bevor Sie speichern.",
        "all_customers_signed": "Alle angeforderten Kunden haben bereits unterschrieben. Die Dokumente müssen noch von den Vertretern von {client_name} unterschrieben werden, und das Angebot wird genehmigt, sobald sie unterschrieben haben. Von Ihrer Seite ist keine weitere Aktion erforderlich.",
        "browserNotSupported": "Wir haben festgestellt, dass Ihr mobiler Browser elektronische Unterschriften möglicherweise nicht unterstützt. Falls Probleme auftreten, wechseln Sie bitte den Browser oder das Gerät, oder laden Sie stattdessen ein unterschriebenes Dokument hoch.",
        "customer_signatories": "Kundenunterzeichner",
        "customers_left_to_sign": "1 Kunde muss noch unterschreiben | {customers_left_to_sign} Kunden müssen noch unterschreiben",
        "customers_required_to_sign": "Noch 1 Kunde muss die Dokumente unterschreiben. | Noch {customers_left_to_sign} Kunden müssen die Dokumente unterschreiben.",
        "customers_signed_names": "Kunden haben bereits unterschrieben: {names}",
        "document_image_data_error": "Bilddaten des Dokuments konnten nicht geladen werden.",
        "document_load_error": "Dokument konnte nicht geladen werden. Bitte prüfen Sie, ob die Datei gültig ist.",
        "document_url_missing_error": "Dokument-URL fehlt.",
        "documents_to_sign": "Zu unterschreibende Dokumente",
        "draw_signature": "Zeichnen Sie Ihre Unterschrift unten",
        "employee_signatories": "{client_name}-Unterzeichner",
        "employees_signed_names": "Teammitglieder haben bereits unterschrieben: {names}",
        "empty_signature_warning": "Bitte zeichnen Sie zuerst Ihre Unterschrift.",
        "marked": "Position der Unterschrift markiert",
        "next": "Weiter",
        "no_signature_indicators_warning": "Bitte geben Sie durch Klicken auf die Seite(n) an, wo das Dokument unterschrieben werden muss.",
        "ok": "OK",
        "original": "Original",
        "page": "Seite",
        "place_signature_subtitle": "Klicken Sie auf die Seite(n), auf denen der Kunde elektronisch unterschreiben soll",
        "place_signature_title": "Unterschriftsposition markieren",
        "read_and_sign": "Ich habe gelesen und möchte unterschreiben",
        "read_documents": "Bitte lesen Sie die folgenden Dokumente, bevor Sie sie unterschreiben",
        "remove": "Entfernen",
        "requesting_signage": "Unterschrift angefordert von",
        "save_error": "Beim Speichern ist ein Fehler aufgetreten.",
        "sign": "Unterschreiben",
        "signatories_for_all_documents": "Die Anzahl der Unterzeichner gilt für alle Dokumente. Wenn Sie sie ändern, werden alle Unterschriften entfernt und Sie müssen sie erneut hinzufügen.",
        "signatureNotPossible": "Elektronische Unterschriften sind für diesen Dateityp nicht verfügbar",
        "signatureNotPossibleSize": "Elektronische Unterschriften sind für Dateien über 40 MB nicht verfügbar",
        "signatures_pending_from_client": "Unterschriften vom Team {client_name} ausstehend",
        "signed": "Unterschrieben",
        "signed_progress": "Unterschrieben: {already_signed_count} von {all_required_to_sign_count}",
        "specifyWhereToSign": "Unterschriftsposition markieren",
        "team_member": "Teammitglied",
        "team_member_signature_warning": "Sie können Unterschriften von Teammitgliedern anfordern, nachdem Sie Unterschriften von Kunden angefordert haben.",
        "thank_you_for_signing": "Vielen Dank für Ihre Unterschrift.",
        "toBeSigned": "Zu unterschreiben",
        "troubleSigningUpload": "Probleme beim Unterschreiben? Laden Sie stattdessen ein unterschriebenes Dokument hoch"
      }
    }
  }
}
